import { get, post } from "@/utils";

export const GET_INITCOINDATA = (parmas = {}) => new Promise(async (resolve, reject) => {
  try {
    const res = await get('/coin/lists', parmas)
    resolve(res)
  } catch (error) {
    reject(error)
  }
})

export const NEW_GET_INITCOINCHARTDATA = (parmas = {}) => new Promise(async (resolve, reject) => {
  try {
    const res = await get('/coin/data/lists', parmas)
    resolve(res)
  } catch (error) {
    reject(error)
  }
})
export const GET_ASSETSLIST = () => new Promise(async (resolve, reject) => {
  try {
    const res = await get('/coin/user/amount')
    resolve(res)
  } catch (error) {
    reject(error)
  }
})

export const COINTRADE = (params) => new Promise(async (resolve, reject) => {
  try {
    const res = await post("/coin/trans/add", params);
    resolve(res)
  } catch (error) {
    reject(error)
  }
})

export const GET_COINTRADEORDER = (params) => new Promise(async (resolve, reject) => {
  try {
    const res = await get("/coin/trans/lists", params);
    resolve(res)
  } catch (error) {
    reject(error)
  }
})

export const COINTRADECLOSE = (id) => new Promise(async (resolve, reject) => {
  try {
    const res = await post("/coin/trans/close", { id });
    resolve(res)
  } catch (error) {
    reject(error)
  }
})

export const GET_LOTTERYRECORD = (params) => new Promise(async (resolve, reject) => {
  try {
    const res = await post("/coin/order/lists", params);
    resolve(res)
  } catch (error) {
    reject(error)
  }
})

export const CONTRACT_TIMEORDER = (params) => new Promise(async (resolve, reject) => {
  try {
    const res = await post("/coin/order/add", params);
    resolve(res)
  } catch (error) {
    reject(error)
  }
})

export const COINCONTRACTADD = (params) => new Promise(async (resolve, reject) => {
  try {
    const res = await post("/coin/contract/add", params);
    resolve(res)
  } catch (error) {
    reject(error)
  }
})

export const CONTRACT_RECORD = (params) => new Promise(async (resolve, reject) => {
  try {
    const res = await post("/coin/contract/lists", params);
    resolve(res)
  } catch (error) {
    reject(error)
  }
})
// 平仓
export const CLOSE_CONTRACT = (params) => new Promise(async (resolve, reject) => {
  try {
    const res = await post("/coin/contract/close", params);
    resolve(res)
  } catch (error) {
    reject(error)
  }
})
// 撤单
export const CANCEL_COINTRACT = (params) => new Promise(async (resolve, reject) => {
  try {
    const res = await post("/coin/contract/cannel", params);
    resolve(res)
  } catch (error) {
    reject(error)
  }
})
